import { render, staticRenderFns } from "./FeaturedReview.vue?vue&type=template&id=3e710bb6"
import script from "./FeaturedReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeaturedReview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Stars: require('/vercel/path0/components/Stars.vue').default})
